import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CustomContentOnPageComponentLoader } from '@confluence/custom-content-page/entry-points/CustomContentOnPageComponentLoader.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const CustomContentOnPageRoute: {
	({ params: { contentId, spaceKey, type } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { contentId, spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
				contentId: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { contentId, spaceKey, type } }: RouteMatch): React.JSX.Element => {
	return (
		<CustomContentOnPageComponentLoader
			contentId={contentId}
			spaceKey={spaceKey}
			type={type === 'undefined' ? '' : type}
		/>
	);
};

CustomContentOnPageRoute.NAVIGATION_PARAMS = ({
	name,
	params: { contentId, spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
			contentId: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'customContentOnPage',
			id: contentId,
		},
		pageState: {
			routeName: name,
			spaceKey,
			contentId,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});
